import styled from 'styled-components'


const IconUi = styled.i`
  color: red;
`

export default IconUi

